export const AI_IMAGE_METADATA_BOARD_SLUG = "ai2";

/** 保存設定と現在URLの対象板から、実際にメタデータ機能を有効にするか決める。 */
export function resolveAiImageMetadataEnabled(
  configuredValue: boolean,
  currentUrlSlug: string | null,
): boolean {
  return currentUrlSlug === AI_IMAGE_METADATA_BOARD_SLUG && configuredValue;
}
